/**
 * SCWT-PM-V2 Phase 3 — Placeholder tab.
 * Used for Landlords / Book / Tests / Retests / Marketing until their
 * Phase 4+ builds land. Keeps the tabbed UI consistent while ops runs
 * the free onboarding pilot.
 */
export default function PmPlaceholderTab({ testid, title, subtitle, comingIn }) {
  return (
    <div data-testid={testid} className="bg-white rounded-2xl border border-slate-200 border-dashed p-8 text-center">
      <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-bold text-slate-400 mb-3">
        Coming next
      </div>
      <h2 className="text-lg font-bold text-slate-800">{title}</h2>
      <p className="text-sm text-slate-500 mt-2 max-w-md mx-auto">{subtitle}</p>
      {comingIn && (
        <div className="mt-4 inline-flex items-center gap-1.5 text-xs bg-slate-100 text-slate-600 rounded-full px-3 py-1">
          Available in {comingIn}
        </div>
      )}
    </div>
  );
}
